import {
  Component, OnDestroy
} from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  ToastController,
  ModalController,
  AlertController
} from "ionic-angular";

import {
  APIServiceProvider
} from "../../common/services/api.service";
import {
  HelperServiceProvider
} from "../../common/services/helper.service";
import {
  NotifyService
} from "../../services/notify.service";
import {
  MixpanelService
} from "../../services/mixpanel.service";
import { Subscription } from "rxjs";
import { environment } from "../../environments/environment";

@Component({
  selector: "modal-orderdelivered",
  templateUrl: "./orderdelivered.modal.html"
})
export class OrderDeliveredModalPage implements OnDestroy {
  invalidAmountMsg = "Please Enter the Valid Amount";
  amountGtrPendingAmountMsg = "Amount can not be greater than Pending amount";
  public amount: any;
  public request_order_status: any;
  paymentRequestSubscription: Subscription;
  public allowed_pay_mode: any;
  paymentLinkStatus: "notSend" | "send" = "notSend";
  public order = {};
  public statusData = [{
    id: 4,
    value: "Delivered"
  }, {
    id: -1,
    value: "Cancelled"
  }];
  public orderData = {
    order_status: 5,
    cancel_reason_id: null,
    cancel_reason_text: null,
  };
  payment_category_Rules: any = {
    "Cash": {

      "Cash": {
        val: true,

      },
      "Payment Link": {
        val: false,

      },

      "QR Code": {
        val: false,

      },
      "Bank Collect": {
        val: false
      }
    },
    "Online": {

      "Cash": {
        val: false,

      },
      "Payment Link": {
        val: true,

      },
      "QR Code": {
        val: true,

      },
      "Bank Collect": {
        val: true
      }

    },
    'Any': {

      "Cash": {
        val: true,

      },
      "Payment Link": {
        val: true,

      },
      "QR Code": {
        val: true,

      },
      "Bank Collect": {
        val: true
      }

    }
  }
  paymentRequestWaiting: boolean = false;
  selectPaymentMode: any = 'Cash'
  payment_txn_id: any;
  payment_category: any;
  public cancel_list: any = [];
  public submitDisabled = false;
  paymentRes: any;
  qrCode: any;
  paymentLinkExpireTimeLeft: any;

  paymentLinkTimerClear: any = null;
  public selectedPaymentMethod:boolean=true;
  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public mixpanelService: MixpanelService,
    private apiHelper: APIServiceProvider,
    public toastCtrl: ToastController,
    public helperService: HelperServiceProvider,
    public notifyService: NotifyService,
    private alertController: AlertController

  ) {
    this.order = this.navParams.get("order");
    console.log(this.order);

    this.request_order_status = this.navParams.get("request_order_status");
    this.allowed_pay_mode = this.navParams.get("allowed_pay_mode");
    // this.order["received_date"] = moment(this.order["received_date"])
    //   .format("DD-MMM-YYYY HH:mm:s")
    //   .toString();

    this.orderData["order_id"] = this.order["order_id"];
    this.getCancelList();

    this.amount = this.order['order_payment_detail']['pending_amount'];
    console.log(this.allowed_pay_mode);

    let p_cat = 'Cash';

    if (this.order["order_payment_detail"]) {
      p_cat = this.order["order_payment_detail"].payment_category;
    }

    this.payment_category = this.payment_category_Rules[p_cat];

    for (var key in this.payment_category) {
      if (this.allowed_pay_mode.indexOf(key) != -1) {
        if (this.payment_category[key].val) {
          this.selectPaymentMode = key;
          break
        }
      }
    }
    this.amount = this.order["order_payment_detail"].pending_amount;
    console.log(this.amount);
    if (this.amount != "0.00" && p_cat != 'Cash') {
      this.onlinePayment("status", true);
    }
  }


  async alert(msg) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      message: msg,
      buttons: ['OK']
    });

    await alert.present();
  }


  onlinePayment(action_type = "create", refresh = false) {
    if (!this.amount) {
      this.alert(this.invalidAmountMsg);
      return;
    }
    if (this.amount > parseFloat(this.order["order_payment_detail"].pending_amount)) {
      this.alert(this.amountGtrPendingAmountMsg);
      return;
    }

    this.amount = parseFloat(this.amount).toFixed(2);

    this.paymentRequestWaiting = true;

    try {
      if (this.paymentRequestSubscription) {
        this.paymentRequestSubscription.unsubscribe();
      }
    } catch (err) {

    }

    let param = this.orderData["order_id"] + "&payment_mode=" + this.selectPaymentMode + "&amount=" + this.amount + "&request_order_status=" + this.request_order_status + "&action_type=" + (refresh ? "check" : action_type) + "&source=" + "GramUday";
    if (!refresh && this.payment_txn_id) {
      param += "&payment_txn_id=" + this.payment_txn_id;
    }
    this.paymentRequestSubscription = this.apiHelper.post("order/finance/online-payment-order-transaction?order_id=" + param, {}, null, action_type == "status" && !refresh ? false : null)
      .subscribe(result => {
        this.paymentRequestWaiting = false;

        if (action_type == "cancel" ){
          this.paymentLinkStatus = "notSend";
          this.clearTimer();
          this.qrCode = null;
          this.helperService.presentToast(result["data"]?.message);
        return;
      }

      if (this.paymentRes?.payment_data.gp_api_response_data?.payment_status == 57 || this.paymentRes?.payment_data.gp_api_response_data?.payment_status == 54 || this.paymentRes?.payment_data.gp_api_response_data?.payment_status == 56) { //57 for Expired, 54 for Received, 56 for Canceled
        this.paymentRes = null;
        return;
      }
      this.paymentRes = result["data"];
        if (refresh) {
         
            this.setTimer(this.paymentRes?.payment_data.gp_api_response_data?.payment_expiry_in_sec);
            if (this.paymentRes?.payment_data.gp_api_response_data?.payment_mode) {
              this.selectPaymentMode = this.paymentRes?.payment_data.gp_api_response_data?.payment_mode;
            }
            if (this.paymentRes?.payment_data.gp_api_response_data?.amount) {
              this.amount = this.paymentRes?.payment_data.gp_api_response_data?.amount;
            }

        }
       
     
        this.payment_txn_id = this.paymentRes?.payment_data.gp_api_response_data?.payment_txn_id

        if (this.paymentRes?.payment_data?.gp_api_response_data?.qr_code != '' && this.paymentRes?.payment_data?.gp_api_response_data?.qr_code) {
          this.qrCode = this.paymentRes?.payment_data?.gp_api_response_data?.qr_code;
        }


          this.paymentLinkStatus = "send";

          if (this.paymentRes?.payment_data.gp_api_response_data?.payment_status_name == "Received") {
            this.qrCode = null;
            this.clearTimer();

            this.helperService.presentToast(this.paymentRes.message);

          }

          if (this.paymentRes?.payment_data.gp_api_response_data?.payment_status_name == "Canceled") {
            this.paymentLinkStatus = "notSend";
            this.clearTimer();
            this.qrCode = null;
            this.helperService.presentToast(this.paymentRes.message);

          }

          if (action_type == "create") {
            this.setTimer(this.paymentRes?.payment_data.gp_api_response_data?.payment_expiry_in_sec);
          }
      },
        error => {

          this.paymentRequestWaiting = false;
          if( refresh || error?.error?.msgArray?.gp_api_error_data?.error_code == 101){
            return;
         }
          
            if (error?.error?.msg == "Order has been already Delivered, please refresh the Data!") { // change
              this.helperService.presentToast("Order has been Delivered");
              this.dismiss();
              return;
            }
          
            if (error?.error?.error) {
              this.helperService.presentToast(error.error.msg);
            } else {
              this.helperService.presentToast("Some error occurred, please refresh and try again");
              
            }

            this.submitDisabled = false;
          
        }
      );
  }

  setTimer(sec) {
    this.paymentLinkExpireTimeLeft = sec || 0;

    this.paymentLinkTimerClear = setInterval(() => {
      if (this.paymentLinkExpireTimeLeft <= 0) {

        this.paymentLinkStatus = "notSend";
        this.qrCode = null;
        this.clearTimer();
      } else {

        if (this.paymentLinkExpireTimeLeft % environment.PAYMENT_TIMEOUT == 0 && this.paymentRequestWaiting == false) {
          this.onlinePayment("status");
        }

        this.paymentLinkExpireTimeLeft--;
      }
    }, 1000)
  }
  clearTimer() {
    try {
      clearTimeout(this.paymentLinkTimerClear);
      this.paymentLinkTimerClear = null;
    } catch (e) {

    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  getCancelList() {
    this.apiHelper
      .get("order/get-reason-list")
      .subscribe(response => {
        this.cancel_list = response['data'];
      });
  }

  sendCancel() {
    this.submitDisabled = true;
    this.apiHelper
      .post("v1.2/order/save-order-status/" + this.orderData["order_id"], this.orderData)
      .subscribe(
        result => {
          this.notifyService.OrderModified(true);
          this.submitDisabled = false;
          this.helperService.presentToast("Success");
          this.notifyService.OrderCancelled(true);
          this.viewCtrl.dismiss();
        },
        error => {
          this.helperService.presentToast(error['error'].msg);
          this.submitDisabled = false;
        }
      );
  }



  submitReceived() {

    if(this.order["order_status_name"]=='Delivered'){
      if(this.selectedPaymentMethod){
        if (this.amount==0) {
          this.alert(this.invalidAmountMsg);
          return;
        }
      }
    }
    if(this.order["order_status_name"]=='Received'){
            
      if(this.selectedPaymentMethod){
        console.log(this.amount)
        if (this.amount==0) {
          this.alert(this.invalidAmountMsg);
          return;
        }
      }
  
      else{
        this.amount="0.00";
      }
    }
  
    


    if (!this.request_order_status) {
      this.helperService.presentToast("Some error occurred, please refresh and try again");
      this.viewCtrl.dismiss();
      return false;
    }

    let payment_mode = 'Cash';

    if (this.order['order_payment_detail']['pending_amount'] == '0.00') {
      this.amount = "0.00";
      payment_mode = 'Cash';
    }

    this.submitDisabled = true;

    this.apiHelper
      .post("order/finance/update-order-transaction?order_id=" + this.orderData["order_id"] + "&payment_mode=" + payment_mode + "&amount=" + this.amount + "&request_order_status=" + this.request_order_status + "&source=" + "GramUday", {})
      .subscribe(
        result => {
          // this.mixpanelService.track(
          //     "order_delivered", {
          //         order_id: this.orderData["order_id"]
          //     },
          // );

          this.notifyService.OrderModified(true);
          this.submitDisabled = false;
          this.helperService.presentToast("Success");
          this.notifyService.OrderDelivered(true);
          this.viewCtrl.dismiss();
        },
        error => {
          this.helperService.presentToast(
            error['error'].msg
          );
          this.submitDisabled = false;
          this.viewCtrl.dismiss();
        }
      );
  }


  copy() {
    navigator.clipboard.writeText(this.paymentRes?.payment_data?.gp_api_response_data?.payment_link || this.paymentRes?.payment_data.gp_api_response_data?.qr_code).then(() => {
      this.helperService.presentToast("copied");
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });
  }
  ngOnDestroy(): void {
    this.clearTimer();
    if (this.paymentRequestSubscription) {
      this.paymentRequestSubscription.unsubscribe();
    }
  }

  selectedPaymentEvent(event){
    console.log(event);
    this.selectPaymentMode = 'Cash'

  }

}


// WEBPACK FOOTER //
// ./src/modals/orderdelivered/orderdelivered.modal.ts